// Raw ES bucket keys (`audience_age_distribution_max`) mapped to display labels.
// Filter controls must dispatch the raw key as the filter value — never the display
// label — since the backend's `terms` query matches against these raw ES keys.
export const API_AGE_TO_DISPLAY = {
  age18To24: '18-24',
  age25To34: '25-34',
  age35To44: '35-44',
  age45To54: '45-54',
  age55To64: '55-64',
  age65ToInf: '65+',
};

export const DEFAULT_BC_AGE_OPTIONS = Object.keys(API_AGE_TO_DISPLAY);
